export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOI',
  FetchCustomRewardsFromSpi = 'specs.loyalty.FetchCustomRewardsFromSpi',
}
